import { render, staticRenderFns } from "./complaintList.vue?vue&type=template&id=a3c3ad9e&scoped=true&"
import script from "./complaintList.vue?vue&type=script&lang=js&"
export * from "./complaintList.vue?vue&type=script&lang=js&"
import style0 from "./complaintList.vue?vue&type=style&index=0&id=a3c3ad9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c3ad9e",
  null
  
)

export default component.exports